import { getToken, getIcon } from '@/utils/auth'
import { GetUserInfo, GetUserCpTag } from '@/api/index'
import qs from 'qs'
import domain from '@/service/domain'

const state = {
  token: getToken() ? getToken().split('#')[1] : '',
  user: {},
  user_id: getToken() ? getToken().split('#')[0] : '',
  userIcon: getIcon() ? getIcon() : '', // 头像
  userDetail: {}, // 用户详情
  hasPro: false, // 是否发起过项目
  hasPop: false, // 是否拥有店铺
  userCpTag: {}, // CP标签
}

const mutations = {
  serUserInfo(state, info) {
    state.user = info
  },
  currentUser(state) {
    state.userIcon = getIcon() ? getIcon() : '' // 头像
    state.userId = getToken() ? getToken().split('#')[0] : ''
    state.token = getToken() ? getToken().split('#')[1] : ''
  },
  currentUserDetail(state, update) {
    state.userDetail = update
  },
  currentCpInfo(state, update) {
    for(let key in update) {
      state[key] = update[key]
    }
  },
  currentUserCpTag(state, update) {
    state.userCpTag = update
  }
}

const actions = {
  // 获取用户标签
  async getCpTag({ state, commit }) {
    if (!state.user_id) return
    const { status, data } = await GetUserCpTag()
    if (status == 0) {
      commit('currentUserCpTag', data)
      // 如果不是真CP和泛CP，禁止进入CP后台 --- &&电商也可以进
      if (!data.user_cp_tag_flag && !data.common_user_cp_flag && !data.shop_user_cp_tag_flag && !data.shop_supplier_tag_flag) {
        location.href = domain.www
      }
    }
  },
  // 获取登录CP详情
  async getUserDetail({ state, commit }) {
    if (!state.user_id) return
    const { status, data } = await GetUserInfo({
      user_id: state.user_id
    })
    // if (status == 0 && data.is_cp) {
    if (status == 0) {
        commit('currentUserDetail', data)
        let arr = data.cards
        if (arr && arr.length) {
          for(let i = 0; i < arr.length; i++) {
            if (arr[i].type == 5 && arr[i].num > 0) {
              commit('currentCpInfo', { hasPro: true })
            }
            if (arr[i].type == 7 && arr[i].num > 0) {
              commit('currentCpInfo', { hasPop: true })
            }
          }
        }
    } else {
      location.href = domain.www
    }
  },
  // 更新用户信息
  getCpUserInfo({ commit }) {
    return new Promise((resolve) => {
        const query = qs.parse(window.location.search, { ignoreQueryPrefix: true })
        if (query['MDUSERTOKEN'] && query['MDUSERTOKEN'].length > 3) {
          localStorage.setItem("MDUSERTOKEN", query['MDUSERTOKEN'])
          commit('currentUser')
          resolve(true)
        } else {
          location.href = domain.account+'?redirect_url='+window.location.href
          resolve(false)
        }
    })
  },
}

export default {
  state,
  mutations,
  actions
}
